import { Entry } from 'contentful';

import { TypeStateAgencySkeleton } from '../../interfaces/contentful';
import { Container } from '../Container/Container';

import { AgencyItem } from './components/AgencyItem';

interface IProps {
  stateAgencyItems: Entry<TypeStateAgencySkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[];
}

export const StateAgencySection = ({ stateAgencyItems }: IProps) => {
  return (
    <Container data-testid="StateAgencySection">
      {stateAgencyItems.map(agencyItem => {
        const { title, description, email, logo, phoneNumber, website, buttonLink, buttonText } =
          agencyItem.fields;
        const imageUrl = logo?.fields.file?.url;
        const imageH = logo?.fields.file?.details.image?.height;
        const imageW = logo?.fields.file?.details.image?.width;

        return (
          <AgencyItem
            key={agencyItem.sys.id}
            title={title}
            description={description}
            email={email}
            logo={imageUrl}
            phoneNumber={phoneNumber}
            website={website}
            buttonLink={buttonLink}
            buttonText={buttonText}
            imageH={imageH}
            imageW={imageW}
          />
        );
      })}
    </Container>
  );
};
